import * as React from "react";
const SvgPaperPlane = props => <svg viewBox="0 0 44 44" {...props}><path d="m27.7 41.8 12.7-35 1-2.9-39.3 8.7 18.6 9.6zm0-8.7-4.2-11.5 12.2-10.7zm6.1-24.4L21.6 19.3l-10.8-5.6z" /></svg>;
export default SvgPaperPlane;